import { BookingParams, BookingPosition, BookingResult } from '../types';
import { selectWorld } from '../world/world-selector';

/**
 * Verteilt eine Buchung zweidimensional: zuerst die Welt (aus
 * `params.context.system` via `selectWorld`), dann die Quelle
 * (`world.actionFor`). Die Action dispatcht intern weiter über `targetType`.
 */
export class ActionTranslator {
  /**
   * Wählt Welt und Quell-Action und delegiert die Buchung. Gibt einen
   * Fehler zurück, wenn die Quelle in der gewählten Welt keine Action hat.
   *
   * @param position Zu buchende Position (article_id und amount)
   * @param params Buchungskontext, Adapter und stabile client_ids
   * @returns BookingResult der delegierten Action bzw. Fehler bei fehlender Action
   */
  public async translateToAction(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    const world = selectWorld(params.context.system);
    const action = world.actionFor(params.context.booking.sourceType);
    if (!action) {
      return {
        success: false,
        message:
          `Booking source ${params.context.booking.sourceType} ` +
          `is not available in world '${world.kind}'`,
      };
    }
    return action.execute(position, params);
  }
}
